export const XCSRF_TOKEN_HEADER = 'X-CSRF-Token';
export const STATES_UPDATE_INTERVAL = 5 * 1000; //ms
export const STATES_FULL_UPDATE_INTERVAL = window.useSinceForStates
   ? 60 * 1000
   : STATES_UPDATE_INTERVAL; //ms

export const NOTIFICATIONS_LENGTH = 198;

export const LICENSE_EXPIRES_NOTIFY_DAYS = 30;

export const bitStrengths = [1024, 2048, 4096];
export const versionNumber = '9.5.0.4620';
export const buildNumber = '20260608';

export const helpUrl = 'https://www.coviantsoftware.com/recommends/diplomat-help-v9-5/';
export const releaseNotesUrl = 'https://www.coviantsoftware.com/recommends/diplomat-notes-v9-5/';

export const FOREVER_TIMESTAMP = 1072936800000;

export const auditAuthenticationOptions = ['Windows', 'SQL Server'];
export const emailServerTypes = ['Windows/Unix', 'AS400/IFS', 'AS400/Library', 'MVS/IFS'];
export const emailEncryptionTypes = ['NONE', 'SSL', 'TLS'];

export const WINDOWS_SEP = '\\';
export const UNIX_SEP = '/';
const _FILE_SEPARATOR_REGXP = '(/)|(\\\\)'; //new RegExp(`[\\\/]`, 'gi');
const _WIN_LETTER_ROOT_REGEXP = '[\\w]{1,2}\\:';
export const WIN_LETTER_ROOT_REGEXP = () => new RegExp(`^${_WIN_LETTER_ROOT_REGEXP}`);

export const FILE_SEPARATOR_REGXP = () => new RegExp(_FILE_SEPARATOR_REGXP); //new RegExp(`[\\\/]`, 'gi');

const _UNC_REGEXP = '(//|\\\\\\\\)[\\w]+(/|\\\\)[\\w]+?';
export const UNC_REGXP = () => /\/\/|\\\\/;

export const ROOT_FOLDER_REGEXP = () =>
   new RegExp(
      `^((${_FILE_SEPARATOR_REGXP})|(${_WIN_LETTER_ROOT_REGEXP}\\\\)|(${_UNC_REGEXP}))$`,
      'gi'
   );

export const ALL_FILES_RECURSIVE = '**';
export const JSON_FILE_TYPES = ['*.json'];

export const DEFAULT_NULL_VALUE = '<None>';

export const OK_RESPONSE = 200;
export const UNAUTHORIZED_RESPONSE = 401;

export const KEY_USAGE_PCT = 90;

//default folder names
export const folderNames = {
   ROOT: 'Root',
   KEYS: 'Keys',
   OPENPGP_KEYS: 'OpenPGP Keys',
   PUBLIC_KEYS: 'Public Keys',
   KEY_PAIRS: 'Key Pairs',
   SSH_KEY_PAIRS: 'SSH Key Pairs', //'SSH Client Keys',
   SSH_PUBLIC_KEYS: 'SSH Public Keys',
   SSL_CERTS: 'SSL Certificates',
   SSL_SERVER_CERTS: 'Server SSL Certificates',
   SSL_CLIENT_CERTS: 'Client SSL Certificates',
   PARTNERS: 'Partners',
   PUBLIC_PARTNERS: 'Public Profiles',
   TRUSTED_PARTNERS: 'Trusted Profiles',
   TRANSACTIONS: 'Transactions',
   INBOUND_TRANSACTIONS: 'Inbound',
   OUTBOUND_TRANSACTIONS: 'Outbound',
};

export const MYSQL_DEFAULT_PORT = 3306;
export const SQL_DEFAULT_PORT = 1433;

export const IP_REGEXP = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}($|\/\d{1,2}$)|^(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}$/;

export const EMAIL_DELIMITER = /[,;]+/gi;

export const LOG_ROWS_TO_SEND = process.env.REACT_APP_DEBUG ? 50 : 200;
export const LOG_ROWS_TO_DOWNLOAD = 200;

export const ALL_USERS = 'all users';
export const DIPLOMAT = 'Diplomat';
export const LDAP = 'LDAP';
export const SFTP_GROUPS = 'Groups';
export const SFTP_FILESYSTEM = 'Filesystem';
export const ADMINISTRATOR = 'Administrator';
export const REVIEWER = 'Reviewer';

export const VFS_PATH = '/vfs';
export const VFS_PATH_LENGTH = VFS_PATH.length;

export const INPUT_CHANGE_DEBOUNCE_MS = 300; // MS

export const CERT_PROP_NAME = 'filepath';
